import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './styles/global.css'; // Importación de estilos globales
import habilitarArrastreDeDialogos from './utils/arrastrarDialogos';

// 21 sep 2026: arrastre de diálogos para toda la app (ver
// utils/arrastrarDialogos.js). Se instala una sola vez, acá, porque no
// depende de React ni de ningún componente.
habilitarArrastreDeDialogos();

// Sentry (9 sep 2026): monitoreo de errores en producción. Debe
// inicializarse lo antes posible, antes de renderizar <App />, para
// capturar también errores que ocurran durante el primer render. Si
// REACT_APP_SENTRY_DSN no está configurado (ej. en local) esto no hace
// nada -- mismo patrón que REACT_APP_GOOGLE_CLIENT_ID en este proyecto.
// Nota CRA: solo las variables de entorno con prefijo REACT_APP_ quedan
// disponibles en el bundle del navegador; hay que cargar
// REACT_APP_SENTRY_DSN en Netlify (Site settings → Environment variables),
// no basta con tenerla en Render (esa es la del backend).
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Solo monitoreo de errores por ahora, sin performance tracing ni
    // session replay -- consumen cuota aparte del plan gratuito que no
    // hace falta para el objetivo actual (enterarse cuando algo se
    // rompe en el navegador del cliente).
    tracesSampleRate: 0,
  });
}

// NOTA: antes acá se llamaba a cleanupLocalStorage() en cada carga de la
// app, que borraba TODO localStorage y sessionStorage sin condición alguna.
// Esto rompía el registro y el login: justo después de registrarse o
// iniciar sesión se guarda el token en localStorage y luego la app hace un
// window.location.href (recarga completa) — esa recarga volvía a ejecutar
// este archivo, que borraba el token recién guardado. El resultado: el
// usuario quedaba "deslogueado" inmediatamente después de registrarse, y
// cualquier refresco de página (F5) cerraba sesión a cualquier usuario.
// Se quita por completo; la sesión ahora persiste normalmente en
// localStorage entre recargas, como es el comportamiento esperado.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
